import './SafetyCard.less';
import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Card,
  Modal,
  Button,
  AppLocaleProvider,
  Row,
  Col
} from 'sd-ui-components';
import FormattedDate from '../../Common/FormattedDate';

const {
  FormattedNumber,
  FormattedMessage,
  FormattedHTMLMessage
} = AppLocaleProvider;

@inject('SafetyStore')
@inject('ConfigStore')
@observer
class SafetyScoreCard extends React.Component {
  state = {
    safetyScoreModalVisible: false
  };

  toggleSafetyScoreModal = () => {
    this.setState({
      safetyScoreModalVisible: !this.state.safetyScoreModalVisible
    });
  };

  render() {
    const { SafetyStore } = this.props;

    let circleColorClass = '';
    if (!SafetyStore.loading.getSafetyScore) {
      if (SafetyStore.driverScoreIsNull || SafetyStore.targetScoreIsNull) {
        circleColorClass = 'unknown-threshold';
      } else if (
        SafetyStore.safetyData.driverScore <= SafetyStore.safetyData.targetScore
      ) {
        circleColorClass = 'below-threshold';
      } else {
        circleColorClass = 'above-threshold';
      }
    }

    return (
      <div>
        <Modal
          title={
            <h3>
              <FormattedMessage
                id="App.Safety.SafetyHelpTitle"
                defaultMessage="How is my Safety Score calculated?"
              />
            </h3>
          }
          visible={this.state.safetyScoreModalVisible}
          footer={[
            <Button key="closeButton" onClick={this.toggleSafetyScoreModal}>
              <FormattedMessage
                id="App.Navigation.Close"
                defaultMessage="Close"
              />
            </Button>
          ]}
          wrapClassName="safety-score-modal"
          closable={false}
        >
          <FormattedHTMLMessage
            id="App.Safety.SafetyHelpBody"
            defaultMessage="<p>This number represents your overall performance over the past four weeks.</p><p>Your score will only be calculated if you have driven at least 20 hours over four consecutive weeks. If you don't see a score for a given week, it means you did not meet this criteria.</p><p>Remember that a lower score is better, so 0 is the best you can do!</p>"
          />
        </Modal>
        <Card
          className="safety-card"
          data-automation-id="sd-ui-driver-safety-score-card"
          loading={SafetyStore.loading.getSafetyScore}
        >
          <Row>
            <Col span={24}>
              <h4 className="safety-score-card-title">
                <a onClick={this.toggleSafetyScoreModal}>
                  <FormattedMessage
                    id="App.Safety.SafetyScoreTitle"
                    defaultMessage="My safety score"
                  />
                </a>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div
                className={`safety-circle ${circleColorClass} ${
                  String(SafetyStore.safetyData.driverScore || 0).length > 3
                    ? 'long-score'
                    : ''
                }`}
              >
                <span
                  className="safety-score"
                  onClick={this.toggleSafetyScoreModal}
                  data-automation-id="sd-ui-driver-safety-driver-score"
                >
                  {SafetyStore.driverScoreIsNull ? (
                    <span>--</span>
                  ) : (
                    <FormattedNumber
                      useGrouping={false}
                      value={SafetyStore.safetyData.driverScore}
                    />
                  )}
                </span>

                {SafetyStore.safetyData.periodEnding && (
                  <span
                    className="safety-score-text"
                    data-automation-id="sd-ui-driver-safety-score-as-of-date"
                  >
                    <br />
                    <FormattedMessage
                      id="App.Safety.AsOf"
                      defaultMessage="As of"
                    />{' '}
                    <FormattedDate
                      value={SafetyStore.safetyData.periodEnding}
                      day="2-digit"
                      month="2-digit"
                      year="2-digit"
                      timeZone={
                        this.props.ConfigStore.config.standardizedTimezone
                      }
                    />
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}

export default SafetyScoreCard;



// WEBPACK FOOTER //
// ./src/containers/Safety/SafetyCards/SafetyScoreCard.jsx